import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { Row, Col, Form, Modal } from "react-bootstrap";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import AddBrandModal from "../Brands/Add";

// const AddBrandModal = ({ show, handleClose, onBrandCreated }) => {
//   const { postData } = useContext(Context);
//   const [showModal, setShowModal] = useState({ code: 0, message: "" });

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();

//   const onSubmit = async (data) => {
//     const formData = new FormData();
//     formData.append("name", data.name);
//     if (data.image?.[0]) formData.append("image", data.image[0]);

//     const res = await postData("/masters/brand", formData);

//     if (res?.success) {
//       setShowModal({ code: 1, message: res.message });
//       onBrandCreated(res.data);
//       handleClose();
//     } else {
//       setShowModal({
//         code: 0,
//         message: res.message || "Failed to create brand",
//       });
//     }
//   };

//   const [imagePreview, setImagePreview] = useState(null);
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setImagePreview(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };

//   return (
//     <>
//       <Modal show={show} onHide={handleClose} size="lg" centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Add New Brand</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmit(onSubmit)}>
//             <Row>
//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Brand Name</Form.Label>
//                   <Form.Control
//                     {...register("name", {
//                       required: "Brand name is required",
//                     })}
//                     isInvalid={errors.name}
//                   />
//                   {errors.name && (
//                     <span className="text-danger">{errors.name.message}</span>
//                   )}
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group>
//                   <Form.Label>Image</Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="image/*"
//                     {...register("image")}
//                     onChange={handleImageChange}
//                   />
//                   {imagePreview && (
//                     <img
//                       src={imagePreview}
//                       alt="Preview"
//                       style={{ maxWidth: "100px", marginTop: "10px" }}
//                     />
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>

//             <div className="d-flex justify-content-center mt-4">
//               <CancelButton name="Cancel" handleClose={handleClose} />
//               <SaveButton name="Save" handleSubmit={handleSubmit(onSubmit)} />
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {showModal.message && (
//         <ModalSave
//           message={showModal.message}
//           showErrorModal={showModal.code === 0}
//         />
//       )}
//     </>
//   );
// };

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);

  const [brands, setBrands] = useState([]);
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [imagePreview, setImagePreview] = useState(null);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const loadBrands = async () => {
    const res = await getData("/allbrands");
    if (res?.success) {
      const formatted = await Select2Data(res.data, "brand_id");
      setBrands(formatted);
    }
  };

  useEffect(() => {
    loadBrands();
  }, []);

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("brand_id", data.brand_id?.value);
    if (data.image?.[0]) formData.append("image", data.image[0]);

    const response = await postData("/masters/seller-brand", formData);

    if (response?.success) {
      await loadBrands();
      await setShowModal({ code: response.code, message: response.message });
    } else {
      await setShowModal({ code: response.code, message: response.message });
    }
    setTimeout(() => {
      setShowModal(0);
      props.handleClose();
    }, 1000);
  };

  const handleBrandCreated = (newBrand) => {
    const newOption = { value: newBrand.id, label: newBrand.name };
    setBrands((prev) => [...prev, newOption]);
    reset({ brand_id: newOption });
  };

  return (
    <>
      <Modal {...props} onHide={props.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Seller Brand</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="justify-content-center">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Brand</Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <Controller
                      name="brand_id"
                      control={control}
                      rules={{ required: "Please select a brand" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={brands}
                          className="w-100"
                          styles={{
                            control: (base) => ({
                              ...base,
                              borderColor: errors.brand_id
                                ? "red"
                                : base.borderColor,
                            }),
                          }}
                        />
                      )}
                    />
                    <button
                      type="button"
                      className="btn btn-success"
                      style={{ width: "40px", height: "38px", padding: "0" }}
                      onClick={() => setShowBrandModal(true)}
                    >
                      +
                    </button>
                  </div>
                  {errors.brand_id && (
                    <span className="text-danger">
                      {errors.brand_id.message}
                    </span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-center mt-5">
              <CancelButton name="Cancel" handleClose={props.handleClose} />
              <SaveButton name="Save" handleSubmit={handleSubmit(onSubmit)} />
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <AddBrandModal
        loadBrands={loadBrands}
        show={showBrandModal}
        handleClose={() => setShowBrandModal(false)}
        onBrandCreated={handleBrandCreated}
      />

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
